import { useCallback, useState } from 'react';

const STORAGE_KEY = 'sidebar:open-keys';

// Ant Menu без контролируемых openKeys держит раскрытие подменю во внутреннем
// стейте, и каждая перезагрузка сворачивает все списки. Читаем сохранённое
// один раз при инициализации; битое или недоступное хранилище означает
// обычный старт со свёрнутым меню.
const readStoredOpenKeys = (): string[] => {
  try {
    const rawValue = window.localStorage.getItem(STORAGE_KEY);
    if (!rawValue) return [];

    const parsed: unknown = JSON.parse(rawValue);

    return Array.isArray(parsed)
      ? parsed.filter((key): key is string => typeof key === 'string')
      : [];
  } catch {
    return [];
  }
};

// Раскрытые пункты бокового меню, переживающие перезагрузку страницы.
// Состояние одно на десктопное и мобильное меню — это одна и та же навигация.
export const useSidebarOpenKeys = () => {
  const [openKeys, setOpenKeys] = useState<string[]>(readStoredOpenKeys);

  const onOpenChange = useCallback((keys: string[]) => {
    setOpenKeys(keys);
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(keys));
    } catch {
      // Хранилище может быть недоступно (приватный режим) — меню просто не
      // запомнит раскрытие до следующей перезагрузки.
    }
  }, []);

  return { openKeys, onOpenChange };
};
